module.exports = __webpack_public_path__ + "img/step2-c.e1e358b4.png";